import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { reloadScriptAccordion, reloadScriptAccordionSubject } from './../components/accordion';
import { reloadScriptSlider } from './../components/slider';
import { reloadScriptVideo } from './../components/video-player';

let studyProgramDetailMainEl = $('.study-program-detail-main');

$(function () {
    if (studyProgramDetailMainEl.length > 0) {
        studyProgramDetailMainEl.each(function () {
            studyProgramDetail($(this));
        });
    }
});

const studyProgramDetail = async listEl => {

    const filter = {
        lang: listEl.data('lang'),
        programName: listEl.data('study-program-name'),
    };

    const data = await getStudyProgram(filter);
    const url = new URL(window.location);
    var dataChangeHtml = data.html;
    dataChangeHtml = replaceAll(dataChangeHtml, SITE_PARAMS.api_url + '/en/studijni-programy', url.origin + '/en/studijni-programy');
    dataChangeHtml = replaceAll(dataChangeHtml, SITE_PARAMS.api_url + '/studijni-programy', url.origin + '/studijni-programy');
    listEl.html(dataChangeHtml);

    var documentTitle = $(dataChangeHtml).find('h1.banner__title').html();
    document.title = documentTitle.replace(/<\/?[^>]+(>|$)/g, "");

    bindStudyProgram();
    reloadScriptAccordion();
    reloadScriptAccordionSubject();
    reloadScriptSlider();
    reloadScriptVideo();

    studyProgramSpecializationSubject();
};

const getStudyProgram = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.api_url + '/wp-json/mendelu/v1/study-program/detail', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        let result = {};
        result.html = '';
        console.log(e);
        return result;
    }
};

const bindStudyProgram = () => {

    let studyProgramDetailEl = $('.study-program');

    $(function () {
        if (studyProgramDetailEl.length > 0) {
            studyProgramDetailEl.each(function () {
                $(this).on('click', ".study-program__top-button", function () {
                    smoothscroll($('#addition-information'), 70);
                });
            });
        }
    });

    $(document).on("click", '.study-program__programs-button-first,.study-program__programs-button', function(event) {
        event.preventDefault();
    });

    $(document).on("mousedown", '.study-program__programs-button-first,.study-program__programs-button', function(event) {
        var decodeUrl = $(this).attr('href');
        const url = new URL(window.location);
        if (url.searchParams.has('rup')) {
            var encodeUrl = url.searchParams.get('rup');
            decodeUrl = atob(encodeUrl);
        }
        switch (event.which) {
            case 1:
                window.location.href = decodeUrl;
                break;
            case 2:
                window.open(decodeUrl);
                break;
            case 3:
                var $this = $(this);
                $this.attr('href', decodeUrl);
                break;
            default:
        }
    });

    changeCountSubject();
};

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}

$(document).ready(changeCountSubject);
$(window).on('resize', changeCountSubject);

function changeCountSubject() {
    var documentWidth = $(this).width();
    
    $('.accordion-subject').each(function() {
        var firstColumnLi = $(this).find('.study-program__required li');
        var secondColumnLi = $(this).find('.study-program__elective-optional li');

        var showButton = false;
        if (documentWidth > 991) {
            var i = 0;
            firstColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
            var i = 0;
            secondColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
        } else {
            var i = 0;
            firstColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
            secondColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
        }

        if (showButton) {
            $(this).find('.showMore').css('display', 'flex');
        }
    });
}

$(document).on("click", '.study-program__subject-accordion .showMore__item', function(event) {
    var $this = $(this);
    var accordion = $this.parent().parent();
    var firstColumnLi = accordion.find('.study-program__required li');
    var secondColumnLi = accordion.find('.study-program__elective-optional li');

    firstColumnLi.each(function() {
        $(this).css('display', 'block');
    });
    secondColumnLi.each(function() {
        $(this).css('display', 'block');
    });
    $this.parent().css('display', 'none');
});

const studyProgramSpecializationSubject = () => {
    const ulElements = document.querySelectorAll('.study-program__subject-specialization-text');

    ulElements.forEach(ul => {
        const itemCount = ul.children.length;
        ul.classList.add(`items-${itemCount}`);
    });
};
